import { ButtonColor } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { GrayExclamationCircleIcon } from "../icon/GrayExclamationCircleIcon";
import { Body16Regular } from "../typography/Body16Regular";
import { H4 } from "../typography/H4";

export const MobileWarningPanel = () => {
  const historyBack = () => {
    window.history.back();
  };

  return (
    <div className="h-full w-full bg-grayscale-contrast-2 flex items-center justify-center">
      <div className="bg-primary-white pt-[27.5px] pb-[24px] px-[16px] rounded-[8px] border-[1px] border-semantic-divider">
        <div className="flex flex-col items-center box-border gap-[16px]">
          <GrayExclamationCircleIcon size={35} />
          <H4 className="text-semantic-text-heading">
            데스크톱 환경에서 이용해 주시기 바랍니다
          </H4>
          <div className="flex flex-col items-center">
            <Body16Regular className="text-semantic-text-secondary">
              아카라 마스터 발주몰은 모바일을 지원하지 않습니다.
            </Body16Regular>
            <Body16Regular className="text-semantic-text-secondary">
              데스크톱 환경에서 이용해 주시기 바랍니다.
            </Body16Regular>
          </div>
        </div>
        <div className="flex items-center justify-center w-full pt-[16px]">
          <Button size="sm" color={ButtonColor.PRIMARY} onClick={historyBack}>
            뒤로 가기
          </Button>
        </div>
      </div>
    </div>
  );
};
